"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/RightToolbar/index.vue"));
var _applet = require("@/api/operation/applet");
var _aiPrompt = require("@/api/marketing/fortune/ai-prompt");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AiPromptList',
  components: {
    RightToolbar: _index.default
  },
  data: function data() {
    return {
      loading: false,
      appList: []
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '活动名称',
        prop: 'activityName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '所属应用',
        prop: 'application',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'createTimeStart',
          endKey: 'createTimeEnd',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'configId',
        visible: true,
        label: "ID",
        width: 70
      }, {
        key: 'application',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 160
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 80
      }, {
        key: 'remark',
        visible: true,
        label: "\u5907\u6CE8",
        width: 160
      }, {
        key: 'createTime',
        visible: true,
        label: "\u521B\u5EFA\u65F6\u95F4",
        width: 140
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      (0, _applet.appletListApi)(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query) {
      return (0, _aiPrompt.aiPromptListApi)(query).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.sortTmp = item.sort;
          item.winConfig = item.activityType === 2 ? item.winConfig : 0;
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'application') {
        var target = this.appList.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    //添加商品
    handleAdd: function handleAdd() {
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      this.$router.push({
        path: "/marketing/fortune/ai-prompt/form/0/add"
      });
    },
    //操作
    handleItem: function handleItem(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/fortune/ai-prompt/form/".concat(row.configId, "/").concat(operate)
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _aiPrompt.aiPromptDeleteApi)({
          configId: row.configId
        });
      }).then(function () {
        _this2.refreshList();
        _this2.$modal.msgSuccess('删除成功');
      });
    },
    //修改状态
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      var params = {
        id: row.configId,
        status: row.status
      };
      this.loading = true;
      (0, _aiPrompt.aiPromptStatusChangeApi)(params).then(function (res) {
        _this3.loading = false;
        _this3.$message.success('更新状态成功');
      }).catch(function () {
        _this3.loading = false;
        _this3.$message.error('更新状态失败');
        row.bannerFlag = row.bannerFlag === 1 ? 2 : 1;
      });
    }
  }
};